<template lang="pug">
  .form-group
    label(v-if="showLabel") 公開区分
    div(:class="config[type].richClass")
      label(v-for="option in options", :key="option.value" :data-testid="option.value")

        //- #224 修正 :typeにするとstrictエラー
        input(v-if="config[type].input === 'radio'", type="radio", name="person[openflag]", :value="option.value", v-model="openflag")
        input(v-else, type="checkbox", name="person[openflag]", :value="option.value", v-model="openflag")

        span: i.fa.fa-lg(:class="config[type].inputIcon")
        i.fa(:class="option.icon")
        | &nbsp;{{option.label}}
</template>

<script>
export default {
  name: 'OpenflagField',
  props: {
    /**
     * @param {String} value openflag
     */
    value: { type: [ String, Array ], required: true },
    showLabel: { type: Boolean, required: false, default: true },
    type: { type: String, required: false, default: 'radio' } // 'radio' or 'check
  },
  data () {
    return {
      openflag: '',
      config: {
        radio: { richClass: 'radio radio-rich', input: 'radio', inputIcon: 'fa-dot-circle-o' },
        checkbox: { richClass: 'checkbox checkbox-rich', input: 'checkbox', inputIcon: 'fa-check' }
      },
      options: [
        { label: '公開', icon: 'bcard-fa-person-public', value: '1' }, // this.app_flag.ON
        { label: '非公開', icon: 'bcard-fa-person-private', value: '0' } // this.app_flag.OFF
      ]
    }
  },
  watch: {
    value (newval, oldval) {
      if (newval !== oldval) {
        this.syncOpenflag(newval)
      }
    },
    openflag (newval, oldval) {
      if (newval !== oldval) {
        this.$emit('input', newval)
      }
    }
  },
  created () {
    this.syncOpenflag(this.value)
  },
  methods: {
    syncOpenflag (openflag) {
      this.openflag = openflag
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/molecules/OpenflagField.vue